// import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router';
import { Box } from '@mui/material';

import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import Footer from './Components/Footer';
import ExerciseDetail from './Pages/ExerciseDetail';
import { Bounce } from 'react-reveal';
function App() {
  return (
    <Box width="400px" sx={{ width: { xl: '1488px' } }} m="auto">

      <Navbar />
      <Routes>
        <Route path='/' element={<Home />}></Route>

        <Route path='/exercise/:id' element={<ExerciseDetail />}></Route>

        {/* <Route path='/' element={}></Route> */}
      </Routes>
      <Footer />
    </Box>
  );
}

export default App;
